import script from "./TableNumbersTariffs.vue?vue&type=script&setup=true&lang=js"
export * from "./TableNumbersTariffs.vue?vue&type=script&setup=true&lang=js"

import "./TableNumbersTariffs.vue?vue&type=style&index=0&id=91d2ce3e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-91d2ce3e"]])

export default __exports__